import Styles from './styles.module.css';
import React, { useState, useRef, useEffect } from 'react';

type SchoolItemProps = {
  school: [ string, string, string, string, string, ];
  checkList: string[];
  setCheckList: React.Dispatch<React.SetStateAction<string[]>>;
};

const SchoolItem: React.FC<SchoolItemProps> = ({ school, checkList, setCheckList, }) => {
  
  const handleCheckboxChange = (value: string, checked: boolean) => {
    if (checked && checkList.length <= 9) {
      setCheckList(prev => [...prev, value]);
    } else if (!checked) {
      setCheckList(prev => prev.filter(item => item !== value));
    }
  };

  return (
    <>
    <div className={Styles.items_table}>
      <div className={Styles.items_table_box_1}>
        <input type="checkbox" className={Styles.items_checkbox} value={school[0]}
          checked={checkList.includes(school[0])}
          onChange={(e) => handleCheckboxChange(e.target.value, e.target.checked)} />
        <div className={Styles.items_table_box_post}>
          <h2>{school[1]}</h2>
        </div>
      </div>
      <div className={Styles.items_table_box_2}>
        <h4>{school[2]}</h4>
      </div>
      <div className={Styles.items_table_box_4}>
        <h4>{school[3]}</h4>
      </div>
      <div className={Styles.items_table_box_3}>
        <h4>{school[4]}</h4>
      </div>

      <div style={{ flexGrow: 1 }}></div>
    </div>
    </>
  );
}

export default SchoolItem;
